import { Download, Mail } from "lucide-react";
import { Reveal } from "../../lib/motion";
import { INSTITUTIONS } from "../../lib/siteData";

const BRIEF_URL = "/EverSoul-Investor-Brief.pdf";
const CONTACT_EMAIL = "Greg@eversoul.World";

export const Institutional = () => {
  return (
    <section
      id="invest"
      data-testid="invest-section"
      className="relative py-28 lg:py-44 bg-[#0B0C0F] text-[#F9F8F6] overflow-hidden"
    >
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.4em] text-[#C5B498] mb-6">
                For institutions
              </p>
              <h2 className="font-serif font-light tracking-tight leading-[1.0] text-[clamp(2.25rem,5.4vw,5rem)] max-w-3xl text-balance">
                Infrastructure for the age of personal AI.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl text-[#9A9C9F] text-base sm:text-lg leading-relaxed">
                As voice, likeness, memories, and AI generated identity become part of the
                modern estate, families and institutions will need reliable systems for
                consent, custody, access, inheritance, provenance, revocation, and protection.
              </p>
              <p className="mt-4 max-w-xl text-[#9A9C9F] text-base sm:text-lg leading-relaxed">
                EverSoul is being designed as a future infrastructure layer for institutions
                entrusted with identity, legacy, and intergenerational responsibility.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-12 flex flex-wrap gap-4">
                <a
                  href={`mailto:${CONTACT_EMAIL}?subject=EverSoul%20institutional%20partnership`}
                  data-testid="institutional-partner-btn"
                  className="group inline-flex items-center gap-3 px-7 py-4 rounded-full bg-[#F9F8F6] text-[#0B0C0F] text-sm tracking-wide hover:opacity-90 transition-opacity duration-300"
                >
                  <Mail className="w-4 h-4" />
                  Explore Institutional Partnership
                </a>
                <a
                  href={BRIEF_URL}
                  download
                  data-testid="download-brief"
                  className="group inline-flex items-center gap-3 px-7 py-4 rounded-full border border-white/30 text-[#F9F8F6] text-sm tracking-wide hover:border-white transition-colors duration-300"
                >
                  <Download className="w-4 h-4" />
                  View Investor Brief
                  <span className="text-[#9A9C9F] group-hover:text-white/70 transition-colors">PDF</span>
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.1}>
              <p className="text-[11px] uppercase tracking-[0.3em] text-[#8b8d92] mb-8 lg:pt-2">
                Potential partners
              </p>
              <ul className="space-y-0 border-t border-[#2A2C31]">
                {INSTITUTIONS.map((name, i) => (
                  <Reveal key={name} delay={0.04 * i}>
                    <li className="flex items-baseline gap-4 border-b border-[#2A2C31] py-4">
                      <span className="text-[11px] tracking-[0.3em] text-[#C5B498] shrink-0">
                        {`0${i + 1}`}
                      </span>
                      <span className="font-serif font-light text-[#e6e2d8] text-[clamp(1.2rem,1.8vw,1.6rem)] tracking-tight">
                        {name}
                      </span>
                    </li>
                  </Reveal>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <p
            data-testid="institutional-note"
            className="mt-16 max-w-3xl text-[#9A9C9F] text-sm leading-relaxed border-t border-[#2A2C31] pt-8"
          >
            <span className="text-[#e6e2d8]">
              EverSoul does not replace attorneys, trustees, executors, or fiduciaries.
            </span>{" "}
            It provides a governed system through which an individual's digital intentions
            may be preserved, understood, protected, and carried forward.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
